export default class RecenterControl{
    constructor(props){
        this.center = props.center;
    }

    handleClick = () => {
        // The flyTo action when the button is clicked
        this._map.flyTo({
          center: this.center,
          speed: 0.5,
        });
      }

    onAdd(map){
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = 'trimblemaps-ctrl trimblemaps-ctrl-group recenter';

        this.controlButton = document.createElement('button');
        this.controlButton.className = 'trimblemaps-ctrl-icon icon-recenter';
        this.controlButton.title="Recenter";
        this.controlButton.ariaLabel="Recenter";
        this.controlButton.textContent = '';
        this.controlButton.addEventListener("click", this.handleClick);
        this._container.append(this.controlButton);
        return this._container; 
    }

    setMapCenter(center){
        this.center = center;
    }
    
    onRemove() {
        if (this.controlButton) {
          this.controlButton.removeEventListener('click', this.handleClick);
        }
        this._container.parentNode.removeChild(this._container);
        this._container = undefined;
        this.controlButton = undefined;
        this._map = undefined;
    }
}